export { default } from "./TabsPagination";
